import * as React from 'react';
import moment from 'moment';

import { Select } from '@common/components/form/inputs/select';
import i18n from '../../../../i18n';

const getDate = (base, { amount, type, startOf, endOf }) => {
  let value = moment(base).subtract(amount, type);

  if (startOf) value = moment(value).startOf(startOf);
  if (endOf) value = moment(value).endOf(endOf);

  return value;
};

const options = [{
  value: 0,
  start: { amount: 3, type: 'days' },
  label: i18n.t('network:analytics_date_selector_past_3_days')
}, {
  value: 1,
  start: { amount: 7, type: 'days' },
  label: i18n.t('network:analytics_date_selector_past_7_days'),
}, {
  value: 2,
  start: { amount: 30, type: 'days' },
  label: i18n.t('network:analytics_date_selector_past_30_days'),
}, {
  value: 3,
  start: { startOf: 'year' },
  label: i18n.t('network:analytics_date_selector_this_year'),
}, {
  value: 4,
  start: { startOf: 'isoWeek' },
  end: { amount: 7, type: 'days', endOf: 'isoWeek' },
  label: i18n.t('network:analytics_date_selector_last_week'),
}, {
  value: 5,
  start: { startOf: 'month' },
  end: { amount: 1, type: 'month', endOf: 'month' },
  label: i18n.t('network:analytics_date_selector_last_month'),
}, {
  value: 6,
  start: { startOf: 'year' },
  end: { amount: 1, type: 'year', endOf: 'year' },
  label: i18n.t('network:analytics_date_selector_last_year'),
}];

export const getDates = (index) => {
  const { start, end = { amount: 1, type: 'day' } } = options[index];

  const endDate = getDate(undefined, end);
  const startDate = getDate(endDate, start);

  const daysDiff = endDate.diff(startDate, 'days');

  const comparisonEndDate = (start.startOf && !(end.amount === 1 && end.type === 'days'))
    ? moment(startDate).subtract(1, start.startOf).startOf(start.startOf).add(daysDiff, 'days') // eslint-disable-line newline-per-chained-call
    : moment(startDate).subtract(1, 'days');
  const comparisonStartDate = moment(comparisonEndDate).subtract(daysDiff, 'days');

  return [{ start: startDate, end: endDate }, { start: comparisonStartDate, end: comparisonEndDate }];
};

const DateRangeSelectorComponent = ({ value, onChange }) => (
  <Select
    clearable={false}
    value={value}
    valueKey="value"
    labelKey="label"
    options={options}
    onChange={(option) => onChange({ value: option.value, dates: getDates(option.value) })}
  />
);

export default DateRangeSelectorComponent;
